export default "__VITE_ASSET__BzOcxhwC__"